import { IStandardAPIResponse,  IReadingStatus, IIDCReading, ISearchIdc } from "../../vm";
import { httpClient, handleErrorResp } from "../UtilService";

export async function getIdcReadings(obj:ISearchIdc): Promise<IStandardAPIResponse<Array<IIDCReading>>> {
    try {
      let res = await httpClient<Array<IIDCReading>>(`idc-readings`, "GET",obj);
      return res;
    } catch (err) {
      return handleErrorResp([]);
    }
  }
export async function updateIdcReadingStatus(obj:IReadingStatus): Promise<IStandardAPIResponse<any>> {
    try {
      let res = await httpClient<any>(`idc-readings/status`, "PATCH",obj);
      return res;
    } catch (err) {
      return handleErrorResp([]);
    }
  }
  export async function updateIdcReading(obj:IIDCReading): Promise<IStandardAPIResponse<IIDCReading>> {
    try {
      let res = await httpClient<IIDCReading>(`idc-readings/${obj._id}`, "PATCH",obj);
      return res;
    } catch (err) {
      return handleErrorResp([]);
    }
  }